import {catchError, http} from '../functions/HttpAuth';

export const geUsersClusterData = async () => await http.get('/api/clusters/users').catch(catchError);
